import { datadogRum } from "@datadog/browser-rum"

import { ignoreEmailSet } from "~/store/global"

import { isValidEnvironment } from "./helpers"

export function datadogSetup({
  user,
  tenantId
}: {
  user: { id: string; name: string; email: string }
  tenantId: string
}) {
  const email = user?.email ?? ""
  if (
    !isValidEnvironment ||
    !email ||
    ignoreEmailSet.some((ignoreEmail) => email.includes(ignoreEmail))
  )
    return
  datadogRum.init({
    applicationId: "a1a37bc8-eba9-4320-b738-0e6fc9ffe429",
    clientToken: "pub8065c3178f5f575799214bb24fb4e164",
    site: "datadoghq.com",
    service: "orbitshift-web",
    env: "prod",
    // Specify a version number to identify the deployed version of your application in Datadog
    allowedTracingUrls: [
      "https://stagapi.orbitshift.ai",
      "https://prodapi.orbitshift.ai",
      "https://devapi.orbitshift.ai",
      (url: string) =>
        url.includes("stagapi.orbitshift.ai") ||
        url.includes("prodapi.orbitshift.ai") ||
        url.includes("devapi.orbitshift.ai")
    ],
    version: "1.0.0",
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input"
  })
  datadogRum.setGlobalContext({
    user: {
      id: user.id,
      name: "user-name",
      email: user.email,
      tenant_id: tenantId
    }
  })
  datadogRum.startSessionReplayRecording()
}

export function datadogTrackEvent(
  event: string,
  properties: Record<string, any> | undefined
) {
  const email = (datadogRum?.getGlobalContext()?.user as { email: string })
    ?.email
  if (
    !isValidEnvironment ||
    !event ||
    !email ||
    ignoreEmailSet.some((ignoreEmail) => email.includes(ignoreEmail))
  )
    return
  datadogRum.addAction(event, properties)
}
